import { OBJECT_TYPE } from './objectTypes';
export const EDIT_PROPERTIES_ALLOWLIST = {
  [OBJECT_TYPE.CAMPAIGN]: ['hs_name', 'hs_color_hex', 'hs_all_assigned_business_unit_ids']
};